<template>
  <div>
    <ul class="info-total">
      <li>
        <p
          class="money"
          style="color: #FFEB00"
        >&yen; {{sourceMoneySum}}</p>
        <div>
          <p>余额</p>
        </div>
        <i class="iconfont iconicon-lingqian"></i>
      </li>
      <li>
        <p
          class="money"
          style="color: #FFEB00"
        >&yen; {{waitSettleMoneySum}}</p>
        <div>
          <p>待结算金额</p>
        </div>
        <i class="iconfont iconicon-lingqian"></i>
      </li>
      <li>
        <p
          class="money"
          style="color: #FFEB00"
        >&yen; {{completeSettleMoneySum}}</p>
        <div>
          <p>已结算金额</p>
        </div>
        <i class="iconfont iconicon-lingqian"></i>
      </li>
    </ul>
    <el-form
      :inline="true"
      style="margin-top: 10px"
    >
      <el-form-item>
        <el-input
          type="text"
          v-model="from.serialNum"
          clearable
          placeholder="请输入结算单号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="from.businessId"
          placeholder="商家"
        >
          <el-option
            label="全部"
            :value="null"
          ></el-option>
          <el-option
            v-for="item in shopName"
            :key="item.id"
            :label="item.baseName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算周期">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          @change="datetimerangeChange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="applicationTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          @change="datetimerangeChangeApplication"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="from.status"
          placeholder="状态"
        >
          <el-option
            label="全部"
            :value="null"
          ></el-option>
          <el-option
            label="待结算"
            value="10"
          ></el-option>
          <el-option
            label="已通过"
            value="20"
          ></el-option>
          <el-option
            label="已结算"
            value="30"
          ></el-option>
          <el-option
            label="拒绝"
            value="40"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="from.sourceId"
          placeholder="资金托管方"
        >
          <el-option
            label="全部"
            :value="null"
          ></el-option>
          <el-option
            v-for="item in funds"
            :key="item.sourceId"
            :label="item.sourceName"
            :value="item.sourceId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="from.page = 1,GetBillList()"
        >查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="warning"
          @click="exportExcel"
          :loading="exportLoad"
        >导出excel</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="billList"
      @selection-change="handleSelectionChange"
      min-height="700"
      v-loading="loading"
      border
      max-height="700"
    >
      <!-- <el-table-column fixed :label="statusTitle"> -->
      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        fixed
        label="结算单号"
        align="center"
        prop="serialNum"
        width="220"
      ></el-table-column>
      <el-table-column
        label="商户ID"
        align="center"
        prop="businessId"
        width="150"
      ></el-table-column>
      <el-table-column
        label="商户编号"
        align="center"
        prop="businessSn"
        width="150"
      ></el-table-column>
      <el-table-column
        label="商户名称"
        show-overflow-tooltip
        align="center"
        prop="businessName"
        width="150"
      ></el-table-column>
      <el-table-column
        label="结算金额"
        show-overflow-tooltip
        align="center"
        prop="settleMoney"
        width="100"
      ></el-table-column>
      <el-table-column
        label="提现方式"
        align="center"
        prop="settleTypeStr"
        width="100"
      ></el-table-column>
      <el-table-column
        label="资金托管方"
        align="center"
        prop="financialSourceName"
        width="230"
      ></el-table-column>
      <el-table-column
        label="结算周期"
        align="center"
        prop="settleCycle"
        width="200"
      ></el-table-column>
      <el-table-column
        label="状态"
        align="center"
        prop="statusStr"
        width="80"
      ></el-table-column>
      <el-table-column
        label="申请时间"
        align="center"
        prop="createdAt"
        width="180"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="refund(scope.row)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
      <!-- </el-table-column> -->
    </el-table>
    <div style="display: flex;justify-content: space-between">
      <div class="current-total-money"></div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from.pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
        background
        style="margin-top: 20px"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//引入请求的方法
import {
  getBusinessList,
  getBillList,
  getAmount,
  getFundslist,
  exportExcel,
} from "@/api";

export default {
  name: "bill",
  data() {
    return {
      from: {
        serialNum: "", //订单编号
        businessId: "", //门店信息
        startAt: "", //申请时间
        sourceId: "", //资金托管方
        status: "", //订单状态
        pageIndex: 1, // 当前页
        pageSize: 10, // 每页条数
        settleStartAt: "", //结算周期开始时间
        settleEndAt: "", //结算周期结束时间
        endAtLocalDate: "", //申请结束时间
        startAtLocalDate: "", //申请开始时间
      },
      total: 1, //总条数
      time: [], //结算周期时间段
      shopName: [], // 店铺名称列表,
      funds: [], //获取资金列表
      exportLoad: false,
      applicationTime: [], //申请时间时间段
      billList: [], //计算单列表数据存放
      loading: false, //列表加载控制，
      multipleSelection: [],
      show: true,
      completeSettleMoneySum: "0.00", //已结算金额
      waitSettleMoneySum: "0.00", //待结算金额
      sourceMoneySum: "0.00", //可结算金额
      tableCheck: "false",
    };
  },
  mounted() {
    this.getBusinessList();
    this.GetBillList();
    this.getAmount();
    this.getFundslist();
  },
  methods: {
    //获取订单结算列表
    async GetBillList() {
      try {
        this.loading = true;
        const data = await getBillList(this.from);
        this.billList = data.data.items;
        this.total = Number(data.data.elementCount);
        this.loading = false;
      } catch (e) {
        // console.log(e)
        this.loading = false;
      }
    },
    //获取结算金额
    async getAmount() {
      const data = await getAmount();


      if(data.data.completeSettleMoneySum==""||data.data.completeSettleMoneySum==null){
         this.completeSettleMoneySum="0.00"
      }else{
         this.completeSettleMoneySum = data.data.completeSettleMoneySum;
      }
      
      if (data.data.waitSettleMoneySum == null ||data.data.waitSettleMoneySum == "") {
        this.waitSettleMoneySum = "0.00";
      } else {
        this.waitSettleMoneySum = data.data.waitSettleMoneySum;
      }

      if(data.data.sourceMoneySum==null||data.data.sourceMoneySum==""){
          this.sourceMoneySum="0.00"
      }else{
          this.sourceMoneySum = data.data.sourceMoneySum;
      }

      
    },
    //下载表格
    async exportExcel() {
      this.exportLoad = true;

      // 获取所有的数据
      if (this.multipleSelection.length < 1) {
        const list = await exportExcel(this.from);
        if (!list) {
          this.$message.error("下载模板文件失败");
          this.exportLoad = false;
          return false;
        }
      } else {
        const excel = await import("@/vendor/Export2Excel");
        const list = this.multipleSelection;
        const header = [
          "结束单号",
          "商户id",
          "商家名称",
          "结算金额",
          "提现方式",
          "资金托管方",
          "结算周期",
          "状态",
          "申请时间",
        ];
        // 表格对应的数据字段
        const filterVal = [
          "serialNum",
          "businessId",
          "businessName",
          "settleMoney",
          "settleTypeStr",
          "financialSourceName",
          "settleCycle",
          "statusStr",
          "createdAt",
        ];
        // 多表头宽度
        const merges = ["A1:K1"];

        // 多表头
        let arr = new Array(header.length).fill("");
        // 判断是否有筛选标题
        if (this.statusTitle === null) {
          this.$message.warning("请等待数据加载，稍后重试");
          this.exportLoad = false;
          return false;
        }

        arr[0] = this.statusTitle;
        const multiHeader = [arr];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          multiHeader,
          header, // 标题
          data, // 数据内容
          filename: "结算单", // 默认文档名
          autoWidth: true, // 自动宽度
          bookType: "xlsx", // 导出类型
          merges,
        });
      }

      this.exportLoad = false;
    },

    // 转JSON格式
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //获取资金托管方信息
    async getFundslist() {
      const data = await getFundslist();
      this.funds = data.data.items;
    },
    //获取门店信息
    async getBusinessList() {
      const data = await getBusinessList();
      this.shopName = data.data;
    },
    // 时间选择
    datetimerangeChange(values) {
      if (!values) {
        this.from.settleStartAt = values ? values[0] : null;
        this.from.settleEndAt = values ? values[1] : null;
        return false;
      }

      // console.log(values)
      this.from.settleStartAt = values ? values[0] : null;
      this.from.settleEndAt = values ? values[1] : null;
    },
    //申请时间查询
    datetimerangeChangeApplication(values) {
      if (!values) {
        this.from.startAtLocalDate = values ? values[0] : null;
        this.from.endAtLocalDate = values ? values[1] : null;
        return false;
      }
      this.from.startAtLocalDate = values ? values[0] : null;
      this.from.endAtLocalDate = values ? values[1] : null;
    },
    //详情
    refund(row) {
      this.show = false;
      this.$router.push({
        path: "/detail",
        query: {
          id: row.id,
        },
      });
    },
    // 每页条数改变时
    handleSizeChange(val) {
      this.from.pageSize = val;
      this.GetBillList();
    },
    // 当前页数改变时
    handleCurrentChange(val) {
      this.from.pageIndex = val;
      this.GetBillList();
    },
    //列表复选框被选中时
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.tableCheck = true;
      } else {
        this.tableCheck = false;
      }

      // console.log(val)
    },
  },
};
</script>

<style scoped lang="less">
.info-total {
  margin-bottom: 20px;
  display: flex;

  li {
    position: relative;
    box-sizing: border-box;
    width: 280px;
    height: 140px;
    border-radius: 10px;
    padding: 20px;
    color: #fff;
    margin-right: 20px;
    @left: #41a3fe;
    @right: #42ceff;
    background: -webkit-linear-gradient(left, @left, @right);
    /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, @left, @right);
    /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, @left, @right);
    /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, @left, @right);

    /* 标准的语法 */

    .money {
      font-size: 30px;
      font-weight: bold;
      margin: 10px 0 40px;
    }

    > div {
      display: flex;
      /*justify-content: space-between;*/
      font-size: 18px;
    }

    .iconfont {
      position: absolute;
      right: -10px;
      bottom: -10px;
      font-size: 80px;
      color: rgba(255, 255, 255, 0.4);
    }
  }
}
</style>